<template>
  <v-flex class="pa-1" xs12 sm6 lg4 xl3>
    <v-card
      :class="
        getTheme() == 'dark' ? 'outlined elevation-0' : 'flat elevation-0'
      "
      :style="
        getTheme() == 'dark'
          ? 'border: 1px solid darkgray'
          : 'border-bottom: 1px solid lightgray'
      "
    >
      <v-img
        class="align-start hover-item"
        height="140px"
        :src="item.image.length > 0 ? item.image : usersNewGiftImage"
        @click="
          $store.state.storePhotoGiftOrderDesign.itemSuperCategoryId = item.id;
          $router.push({
            name: 'userNewPhotoGiftOrder',
            params: { subPath: item.title },
          });
        "
      >
        <v-card-title class="overline text-no-wrap">
          <span
            v-if="item.subtitle.length > 0"
            :style="item.whiteText ? 'color: whitesmoke' : 'color: #505050'"
          >
            {{ item.subtitle }}
          </span>
          <span
            v-else
            :style="item.whiteText ? 'color: whitesmoke' : 'color: #505050'"
            >{{ item.subtitle }}</span
          >
        </v-card-title>
        <v-card-subtitle class="text-no-wrap body-1 font-weight-black pb-3">
          <span
            v-if="item.title.length > 0"
            :style="item.whiteText ? 'color: whitesmoke' : 'color: #505050'"
          >
            {{ item.title }}
          </span>
          <span
            v-else
            :style="item.whiteText ? 'color: whitesmoke' : 'color: #505050'"
            >{{ item.title }}</span
          >
        </v-card-subtitle>
        <!-- če je popust celotna super kategorija -->
        <v-btn
          v-if="
            $store.state.storePromoCode.activePromoCodes.filter(
              (x) => !x.hidden && x.superCategory == item.id && x.category == ''
            ).length > 0
          "
          absolute
          bottom
          right
          small
          style="background-color: #cc0000; border-radius: 8px; color: white"
          class="elevation-0"
          @click.stop
          @click="
            $store.state.storePhotoGiftOrderDesign.itemSuperCategoryId =
              item.id;
            $router.push({
              name: 'userNewPhotoGiftOrder',
              params: { subPath: item.title },
            });
          "
        >
          <span style="margin-right: 3px"
            >{{ $t("userNewOrderSummary5aTitle") }}
            {{
              $store.state.storePromoCode.activePromoCodes.filter(
                (x) => !x.hidden && x.superCategory == item.id
              )[0].promoCode
            }}</span
          >
          <span
            v-if="
              $store.state.storePromoCode.activePromoCodes.filter(
                (x) => !x.hidden && x.superCategory == item.id
              )[0].discountType == 'Pct'
            "
          >
            -{{
              $store.state.storePromoCode.activePromoCodes.filter(
                (x) => !x.hidden && x.superCategory == item.id
              )[0].discount
            }}%</span
          >
          <span
            v-else-if="
              $store.state.storePromoCode.activePromoCodes.filter(
                (x) => !x.hidden && x.superCategory == item.id
              )[0].discountType == 'Amt'
            "
          >
            -{{
              price(
                $store.state.storePromoCode.activePromoCodes.filter(
                  (x) => !x.hidden && x.superCategory == item.id
                )[0].discount
              )
            }}</span
          >
        </v-btn>
        <!-- če je popust znotraj super kategorije -->
        <v-btn
          v-else-if="
            $store.state.storePromoCode.activePromoCodes.filter(
              (x) => !x.hidden && x.superCategory == item.id
            ).length > 0
          "
          absolute
          bottom
          right
          small
          style="background-color: #cc0000; border-radius: 8px; color: white"
          class="elevation-0"
          @click.stop
          @click="
            $store.state.storePhotoGiftOrderDesign.itemSuperCategoryId =
              item.id;
            $router.push({
              name: 'userNewPhotoGiftOrder',
              params: { subPath: item.title },
            });
          "
        >
          <v-icon small class="white--text">mdi-sale</v-icon>
        </v-btn>
      </v-img>
      <v-card-actions
        :style="
          getTheme() == 'dark'
            ? 'background-color: #505050'
            : 'background-color: white'
        "
      >
        <v-spacer></v-spacer>
        <home-menu-card-action-btn
          outlined
          :path="'/userNewPhotoGiftOrder/' + item.title"
          icon="mdi-folder-plus"
          :title="$t('lmBtnDesign')"
        ></home-menu-card-action-btn>
        <v-spacer></v-spacer>
        <home-menu-card-action-btn
          :path="'/userGiftPrices/' + item.title"
          icon="mdi-cash-multiple"
          :title="$t('dashboardCardModulePhotoOrderPricesButtonTitle')"
        ></home-menu-card-action-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
      <home-menu-edit-card-btn
        path="/settingsPhotoGiftBasic"
      ></home-menu-edit-card-btn>
    </v-card>
  </v-flex>
</template>

<script>
import HomeMenuEditCardBtn from "@/components/HomeMenuEditCardBtn";
import HomeMenuCardActionBtn from "@/components/HomeMenuCardActionBtn";

export default {
  name: "homeMenuModulePhotoGiftItem",
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  components: {
    HomeMenuCardActionBtn,
    HomeMenuEditCardBtn,
  },
  data() {
    return {
      usersNewGiftImage: require("@/assets/usersNewGift.jpg"),
    };
  },
};
</script>
